import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { IBCSignatureProps } from './entities';
import BCButton from '../BCButton';
import { findMessage } from '../BCIntl';
import Style from './assets/styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(Style);

const BCSignature: React.FC<IBCSignatureProps> = props => {
	const signatureCanvasRef = React.useRef<SignatureCanvas>();

	React.useEffect(() => {
		if (signatureCanvasRef.current) {
			if (props.value) {
				if (props.value !== signatureCanvasRef.current.toDataURL()) {
					signatureCanvasRef.current.clear();
				}

				signatureCanvasRef.current.fromDataURL(props.value);
			} else {
				signatureCanvasRef.current.clear();
			}
		}
	}, [signatureCanvasRef.current, props.value]);

	const renderCanvas = () => (
		<SignatureCanvas
			ref={signatureCanvasRef}
			minWidth={props.minPenSize}
			maxWidth={props.maxPenSize}
			penColor={props.penColor}
			dotSize={props.dotSize}
			onEnd={() => props.onChange(signatureCanvasRef.current.toDataURL())}
			clearOnResize={false}
			canvasProps={{
				style: {
					width: '100%',
					height: '100%',
					backgroundColor: props.backgroundColor
				}
			}}
		/>
	);

	const renderClear = () => {
		if (!props.readonly && !props.disabled) {
			return (
				<BCButton
					onClick={() => props.onChange(null)}
					className={Style.clearButton}
					type="dashed"
				>
					{findMessage.get('100913')}
				</BCButton>
			);
		}
	};

	const containerClassNames = cx({
		container: true,
		showBorder: props.showBorder,
		disabledContainer: props.readonly || props.disabled
	});

	return (
		<div
			style={{ width: props.width, height: props.height }}
			className={containerClassNames}
		>
			{renderCanvas()}
			{renderClear()}
		</div>
	);
};

export default BCSignature;
